export default __webpack_public_path__ + "static/sportplusimg-158d7ff9f2ed188a92c731854eb0b803.png";